<template>
    <div class="hd-bg">
        <div class="header">
            <div class="left"><a href="javascript:;" class="btn return" @click="$router.back()"></a></div>
            <div class="right"><a href="javascript:;" class="btn tel" @click="telConfirm"></a><a href="javascript:;" class="btn user" @click="checkLogined"></a></div>
            <div class="center"><router-link to="/">
			{{isshowlogin?'址点楼盘':'选址中国'}}
			</router-link><div class="city" @click="showCity = true">{{ activeCity }}</div></div>
        </div>
        <van-popup v-model="showCity" position="bottom" :overlay="true">
            <van-picker show-toolbar :columns="cityList" value-key="name"  @cancel="showCity = false" @confirm="onConfirm" />
        </van-popup>
    </div>
</template>

<script>

    import { Popup, Picker, Dialog } from 'vant'
	import {mapState} from 'vuex'
    export default {
        name: "Header",
        data: function () {
            return {
				isshowlogin:true,
                showCity: false
            }
        },
        components: {
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Dialog.name]: Dialog
        },
        mounted() {
			this.$store.dispatch("getaddress")
            //this.getHeaderInfo();
			this.isshowlogin=swan.webView.getEnv().smartprogram
			
        },
		computed:{
			...mapState(['cityList','activeCity'])
		},
        methods: {
            getHeaderInfo () {
                var _this = this;
                _this.api.getCityInfo().then(function(response){
                    _this.cityList = response;
                    if (_this.$store.getters.activeAddr == null) {
						
						console.log(response[0])
						
                        _this.$store.commit('changeActiveAddr', response[0]);
                    }
					
					
                    _this.activeCity = _this.$store.getters.activeAddr.name;
                })
            },
            onConfirm (value, index) {
                this.showCity = false;
				console.log(this.cityList[index])
                this.$store.commit('changeActiveAddr', this.cityList[index]);
                
                this.$store.commit('setActiveAddr', this.cityList[index].name);
                this.$emit('confirm');
            },
            telConfirm () {
                Dialog.confirm({
                    title: '400转接',
                    message: '',
                    confirmButtonText: '确定'
                }).then(() => {
                    window.location.href = "tel:4000080960";
                }).catch(()=>{});
            },
            checkLogined () {
                var _this = this;
                _this.api.getUserInfo().then(function(response){
                    if (response.status == 1) {
                        _this.$router.push('UserCenter')
                    } else {
                        _this.$router.push('Login')
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .hd-bg {height: 1rem;}

    .header {
        position: fixed;top: 0;left: 0;width: 100%;height: 1rem;z-index: 888;
        background-color: #343434;line-height: 1rem;text-align: center;
    }
    .header .btn {
        display: inline-block;vertical-align: middle;width: .36rem;height: .36rem;margin: 0 .15rem;
        background-repeat: no-repeat;background-position: center center;-webkit-background-size: contain;background-size: contain;
    }
    .header .return {background-image: url('../assets/images/icon-return.png');}
    .header .user {background-image: url('../assets/images/icon-head-user.png');}
    .header .tel {background-image: url('../assets/images/icon-head-tel.png');}
    .header .left {
        position: absolute;top: 0;left: .15rem;
    }
    .header .right {
        position: absolute;top: 0;right: .15rem;
    }
    .header .center {
        position: relative;
        display: inline-block;
        font-size: .36rem;color: #ffffff;
    }
    .header .city {
        position: absolute;left: 100%;top: 50%;margin: -.7em .1rem 0;
        white-space: nowrap;font-size: .6em;line-height: 2;
        padding-right: .2rem;background: url("../assets/images/icon-sel3.png") no-repeat right center;-webkit-background-size: .15rem;background-size: .15rem;
    }
</style>